module.exports = __webpack_public_path__ + "static/turquia-003-021569b6a3f5fda0676224e59d54060f.jpg";